<template lang="pug">
  v-navigation-drawer.deep-purple.accent-4(
    app,
    dark,
    permanent,
    :mini-variant="mini",
    transition="slide-x-reverse-transition",
    src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg",
    width="220",
  )
    v-list.py-0
      div(v-for='item in items', :key='item.title')
        v-divider(v-if="item.isDivider")
        v-list-item.d-relative(
          v-else-if="hasPermission(item.permissions)",
          :to="item.to || null",
          :class="item.class",
          @click="logout(item.title)",
        )
          v-list-item-icon
            v-icon {{ item.icon }}
          v-list-item-content.ml-8.pl-2
            v-list-item-title
              span(v-if="item.title === 'profile'") {{ fullName }}
              span(v-else) {{ $t(`sideNav.${item.title}`) }}

    div.locale-selector
      div.locale-mini-display.d-flex.justify-center(v-if="mini")
        v-btn(
          fab,
          @click.prevent="setLocalMini",
        )
          span.text-uppercase {{ $i18n.locale }}
      v-btn-toggle(
        mandatory,
        v-else,
        v-model='locale',
      )
        v-btn(
          light,
          outlined,
          @click="setLocale('en')",
        ) EN
        v-btn(
          light,
          outlined,
          @click="setLocale('thai')",
        ) TH

</template>

<script>
import { roleManager, progressWrapper } from '@/config/mixins.js';

export default {
  mixins: [roleManager, progressWrapper],

  props: {
    mini: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      locale: null,
      items: [
        { isDivider: true },
        {
          title: 'profile',
          to: { name: 'editProfile' },
          icon: 'fas fa-user-circle',
        },
        { isDivider: true },
        {
          title: 'dashboard',
          to: { name: 'dashboard' },
          icon: 'fas fa-chart-area',
        },
        {
          title: 'shop',
          to: { name: 'shops' },
          icon: 'fas fa-store',
          permissions: ['superadmin'],
        },
        {
          title: 'user',
          to: { name: 'users' },
          icon: 'fas fa-users',
        },
        {
          title: 'media',
          to: { name: 'medias' },
          icon: 'fas fa-images',
          permissions: ['superadmin'],
        },
        {
          title: 'redeemable',
          to: { name: 'redeemables' },
          icon: 'fas fa-gifts',
          permissions: ['superadmin'],
        },
        {
          title: 'rewardTemplate',
          to: { name: 'rewardTemplates' },
          icon: 'fas fa-coins',
          permissions: ['superadmin'],
        },
        {
          title: 'systemSettings',
          to: { name: 'medicalConditions' },
          icon: 'fas fa-cog',
          permissions: ['superadmin'],
        },
        { isDivider: true },
        {
          class: 'logout',
          title: 'logout',
          icon: 'fas fa-sign-out-alt',
        },
        { isDivider: true },
      ],
    };
  },

  created() {
    this.locale = this.$i18n.locale;
  },

  computed: {
    fullName() {
      return `${this.authUser.first_name} ${this.authUser.last_name}` || '';
    },
  },

  methods: {
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },

    setLocalMini() {
      const locales = Object.keys(this.$i18n.messages).filter(
        locale => locale !== 'cn',
      );
      const currentIndex = locales.indexOf(this.locale);
      let updatedLocale = locales[currentIndex + 1];

      if (currentIndex === locales.length - 1) {
        updatedLocale = locales[0];
      }

      this.locale = updatedLocale;
      this.$root.$i18n.locale = updatedLocale;
    },

    hasPermission(permission) {
      if (permission) {
        return permission.includes(this.authUser.role);
      }

      return true;
    },

    logout(title) {
      if (title === 'logout') {
        this.$store
          .dispatch('auth/logout')
          .then(() => this.$router.push({ name: 'login' }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  .v-list-item__icon {
    position: absolute;
    top: 0;
    bottom: 0;
  }
}

.v-list-item--active.logout {
  &::before {
    content: none;
  }
}

::v-deep.locale-selector {
  bottom: 0;
  margin-bottom: 16px;
  position: absolute;

  .locale-mini-display {
    width: 64px;
    .v-btn {
      display: flex;
      height: 36px;
      width: 36px;
      color: var(--v-primary-base);
      background-color: white !important;
      // border: 1px solid rgba(255, 255, 255, 0.12);
    }
  }

  .v-btn-toggle {
    padding-left: 12px;
    background: transparent !important;
    .v-btn {
      height: 36px !important;
      min-height: 36px !important;
    }

    .v-item--active {
      color: var(--v-primary-base);
      background: white;
    }

    .v-btn:not(.v-item--active) {
      color: white;
    }
  }
}
</style>
